import {useLocation, useParams} from 'react-router-dom';

import {findValidUrl, isSublocation} from './../shared/helpers/findValidUrl';

import {TypeLocation} from '../shared/types/menu.types';
import {useEffect} from 'react';

export const useRightPath = () => {
  const {pathname} = useLocation();
  const {id} = useParams();
  const validUrl = findValidUrl(pathname) as TypeLocation;
  const sublocationChecking = isSublocation(pathname, id);

  useEffect(() => {
    sessionStorage.setItem('current', sublocationChecking ? pathname : validUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validUrl, sublocationChecking]);

  return {validUrl, sublocationChecking};
};
